import { sep } from 'path';

export const getOriginLocation = () => window.location.origin;

export const getCallbackUrl = (path: string) => new URL(`${path}${sep}`, getOriginLocation()).href;
